import * as React from 'react'
import { useController, useFormContext } from 'react-hook-form'

import {
  FieldElementWrapperProps,
  FieldWrapper
} from '~/components/field-wrapper/FieldWrapper'
import { useFieldError } from '~/components/form/useFieldError'
import { useFormCustomContext } from '~/components/form/useFormCustomContext'
import { SelectMenu } from '~/components/select-menu/SelectMenu'

type SelectMenuFieldProps = React.PropsWithChildren<
  FieldElementWrapperProps & {
    placeholder?: string
    size?: 'sm' | 'md' | 'lg'
    theme?: 'white' | 'grey'
    disabled?: boolean
    className?: string
  }
>

export const SelectMenuField = ({
  className,
  hideLabel,
  children,
  name,
  label,
  validation,
  prompt,
  description,
  theme,
  size,
  placeholder,
  disabled,
  ...remainingProps
}: SelectMenuFieldProps) => {
  const { control } = useFormContext()
  const context = useFormCustomContext()
  const { error } = useFieldError(name)
  const formTheme = context?.theme ?? theme

  const {
    field: { ref, onChange, value }
  } = useController({
    name,
    control,
    rules: validation,
    defaultValue: ''
  })

  return (
    <FieldWrapper
      className={className}
      description={description}
      error={error}
      fieldId={name}
      hideLabel={hideLabel}
      label={label}
      prompt={prompt}
      required={Boolean(validation?.required)}
    >
      <SelectMenu
        value={value}
        onValueChange={onChange}
        size={size}
        theme={formTheme}
        disabled={disabled}
        {...(error && { state: 'error' })}
        {...remainingProps}
      >
        <SelectMenu.Trigger
          ref={ref}
          placeholder={placeholder}
          aria-label={label}
        />
        <SelectMenu.Content>{children}</SelectMenu.Content>
      </SelectMenu>
    </FieldWrapper>
  )
}

SelectMenuField.displayName = 'SelectMenuField'
